import { useMemo } from 'react';
import useCR257ImproveWebSuburbSelectionExperiment from '@/components/organisms/Forms/Fields/useCR257ImproveWebSuburbSelectionExperiment';

/**
 * Signup suburb-step field mapping.
 *
 * CR-236 is stopped (control won), so the default path keeps city-only signup.
 * CR-257 reintroduces the suburb picker as a mandatory chip field on all signup surfaces; the picker itself hides when a city has too few suburbs.
 */
export type SuburbPreferenceSignupStepMode = 'control' | 'mandatory';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormField = any;

export function getSuburbPreferenceSignupFields(
  fields: FormField[] | null | undefined,
  mode: SuburbPreferenceSignupStepMode
): FormField[] {
  const formFields = fields ?? [];

  if (mode === 'control') {
    return formFields.filter((field) => field.name !== 'suburbIds');
  }

  return formFields.map((field) =>
    field.name === 'suburbIds'
      ? {
          ...field,
          required: true,
        }
      : field
  );
}

export function useSuburbPreferenceSignupFields(
  fields: FormField[] | null | undefined
): FormField[] {
  const showImprovedSuburbSelection = useCR257ImproveWebSuburbSelectionExperiment();
  const mode: SuburbPreferenceSignupStepMode = showImprovedSuburbSelection
    ? 'mandatory'
    : 'control';

  return useMemo(() => getSuburbPreferenceSignupFields(fields, mode), [fields, mode]);
}
